<script lang="ts">
  import { Route, Router } from "svelte-routing";
  import Home from "./home/Home.svelte";

  export let url = "";
</script>

<Router {url}>
  <main>
    <Route path="/">
      <Home />
    </Route>
  </main>
</Router>

<style type="text/scss">
  :global {
    @import "src/global.scss";
  }

  main {
    padding: 0;
  }
</style>
